import { render, staticRenderFns } from "./ReportMaterials.vue?vue&type=template&id=8cfa7b52&"
import script from "./ReportMaterials.vue?vue&type=script&lang=js&"
export * from "./ReportMaterials.vue?vue&type=script&lang=js&"
import style0 from "./ReportMaterials.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QExpansionItem,QItemSection,QIcon,QItem} from 'quasar'
component.options.components = Object.assign({QExpansionItem,QItemSection,QIcon,QItem}, component.options.components || {})
